export const DEAFULT_SMS_PARAMS = {
  message: `Hi {{ contact_first_name }}, \nWe have a special offer for you.`,
  source: '',
  medium: '',
};
export const DEAFULT_SMS_PARAMS_WITH_STORY = {
  message: `Hi {{ contact_first_name }}, \nWe have a special offer for you. \nCheck out the page for details {{ story_url }} `,
  source: '',
  medium: '',
};